import dynamic from 'next/dynamic';
const RepscoreComponent = dynamic(() => import('./RepscoreComponent'));

const RepScores = () => {
  return <RepscoreComponent />;
};

export default RepScores;
